import React from 'react';

export const { Consumer, Provider } = React.createContext();

export const withModel = ComponentToWrap => {
  return props => (
    <Consumer>
      {model => <ComponentToWrap {...props} model={model} />}
    </Consumer>
  );
};



// WEBPACK FOOTER //
// ./src/client/js/view/data-providers/model.js